// extracted by mini-css-extract-plugin
module.exports = {"grid":"ProductsModal_grid__3_W_a","button":"ProductsModal_button__VaTcg","iconContainer":"ProductsModal_iconContainer__ONPYZ"};